import { Injectable } from '@angular/core';
import { IBookVisitModel } from '@app/shared/models';
import { BookingStepsFormType } from '@app/shared/models/booking-steps-form-type.model';

@Injectable({
  providedIn: 'root'
})
export class CreateVisitMapperService {
  public bookingForm: BookingStepsFormType;

  public createBookVisitModel(bookingForm: BookingStepsFormType): IBookVisitModel {
    this.bookingForm = bookingForm;
    const requestData: IBookVisitModel = {
      salonId: bookingForm.controls.salonId.value,
      customerId: bookingForm.controls.customerData.controls.id.value,
      customerFirstName: bookingForm.controls.customerData.controls.firstName.value,
      customerLastName: bookingForm.controls.customerData.controls.lastName.value,
      customerNameInfix: bookingForm.controls.customerData.controls.nameInfix.value,
      customerMobile: bookingForm.controls.customerData.controls.country.value.phoneCode + bookingForm.controls.customerData.controls.mobileNumber.value.replace(/^0+/, ''),
      customerCountry: bookingForm.controls.customerData.controls.country.value,
      customerGender: bookingForm.controls.customerData.controls.gender.value,
      customerEmail: bookingForm.controls.customerData.controls.email.value,
      customerPassword: bookingForm.controls.createAnAccount ? bookingForm.controls.password.value : '',
      createCustomerAccount: !bookingForm.controls.createAnAccount.value,
      remark: bookingForm.controls.salonRemarks.value,
      isNewCustomer: bookingForm.controls.isNewCustomer.value,
      treatmentAssignments: bookingForm.controls.treatmentAssingments.getRawValue(),
      visitSlot: bookingForm.controls.visitSlot.value,
      bookedWithWidget: false,
      paymentType: bookingForm.controls.paymentType.value,
      adviceRequested: bookingForm.controls.adviceRequested.value ? bookingForm.controls.adviceRequested.value : false
    };
    return requestData;
  }
}
